/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCommentDto } from '../../models/contents-request-comment-dto';
import { UpdateContentsRequestCommentDto } from '../../models/update-contents-request-comment-dto';

export interface ContentsRequestCommentControllerUpdate$Params {
  commentId: string;
      body: UpdateContentsRequestCommentDto
}

export function contentsRequestCommentControllerUpdate(http: HttpClient, rootUrl: string, params: ContentsRequestCommentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestCommentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('commentId', params.commentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestCommentDto>;
    })
  );
}

contentsRequestCommentControllerUpdate.PATH = '/api/contents-request-comment/{commentId}';
